@if(!mapOnly) {
<mat-toolbar class="content-header" *ngIf="!loading && risk">
  <h1 class="page-title">{{ risk.payload.displayTitle || risk.payload.title }}</h1>
  <span class="toolbar-spacer"></span>

  <mat-slide-toggle *ngIf="risk.payload.lat" (change)="toggleMap($event)" class="map-title" [checked]="showMap">{{'viewer.maps' |
    translate}}</mat-slide-toggle>
  <lib-button [text]="'risks.export' | translate" [color]="'secondary'" [icon]="'download'"
    (click)="exportPDF()" class="download" [loading]="loadingPDF">
  </lib-button>
</mat-toolbar>

<div class="content" *ngIf="!loading">
  <div class="risk" [ngClass]="{'no-map': !showMap }">
      <mat-card  *ngIf="risk" class="risk-card">
        <mat-card-content class="card-content">
          <app-gallery *ngIf="risk && risk.gallery && risk.gallery.url" [id]="risk.gallery.id" [index]="i"
            [name]="risk.gallery.name" [prediction]="risk.payload.prediction || risk.gallery.predictions"
            [craneCycle]="risk.payload.title" [startDate]="risk.payload.startDate" [endDate]="risk.payload.endDate"
            [url]="risk.gallery.url" [tags]="risk.gallery.tags" [project]="project" [metric]="risk"
            [tracker]="risk.tracker" [tagNames]="tagNames" [isDialog]="false" [user]="user"
            [tagDisplayConfig]="tagDisplayConfig" [customVisionIds]="risk.gallery.customVisionIds"
            [processed]="risk.gallery.processed" maxImageHeight="70vh">
          </app-gallery>
          <img src="img/default_project.png" alt="Default risk" class="gallery-img" *ngIf="!risk.gallery?.url">
          <ng-container *ngTemplateOutlet="riskInfoTemplate"></ng-container>
        </mat-card-content>
      </mat-card>
  </div>

  <div *ngIf="showMap && risk?.payload?.lat && risk?.payload?.lon" class="viewer-google-map" #maps>
    <google-map appMapTheme [width]="'100%'" [height]="'100%'" [options]="mapOptions" id="google-map">
    </google-map>
    <ng-container *ngTemplateOutlet="groupButtonTemplate"></ng-container>
  </div>
</div>

<app-spinner *ngIf="loading" fill></app-spinner>
} 
@else {
  <div *ngIf="risk?.payload?.lat && risk?.payload?.lon" class="viewer-google-map map-only" #maps>
    <google-map appMapTheme [width]="'100%'" [height]="'100%'" [options]="mapOptions" id="google-map">
    </google-map>
  </div>
}

<ng-container *ngIf="noData">
  <lib-no-data message="risks.no_risk" icon="search_off"></lib-no-data>
</ng-container>

<!-- Templates -->
<ng-template #riskInfoTemplate>
  <div class="risk-info" [ngClass]="{'no-description': !risk.payload.description }">
    <div class="risk-header">
      <div *ngIf="risk.payload.description" class="group full">
        <div class="label">
          <div class="label">
            <span>{{ "risks.description" | translate }}</span>
            <app-help [text]="helpText" [size]="'16px'" [minWidth]="'150px'"></app-help>
          </div>
        </div>
        <div class="title">
          <h3>{{ risk.payload.description }}</h3>
        </div>
        <mat-divider [style.backgroundColor]="'red'"></mat-divider>
      </div>
    </div>

    <div class="list-rows">
      <div class="group">
        <div class="label">{{ "risks.date" | translate }}</div>
        <div class="value">{{ risk.payload.startDate | timeFormat : "dd/MM/yyyy" }}</div>
      </div>
      <div class="group">
        <div class="label">{{ "risks.hour" | translate }}</div>
        <div class="value">{{ risk.payload.startDate | timeFormat : "HH:mm:ss" }}</div>
      </div>
      <div class="group" *ngIf="risk.payload.sequence">
        <div class="label">{{ "risks.sequence" | translate }}</div>
        <div class="value">{{ risk.payload.sequence }}</div>
      </div>
      <div class="group" *ngIf="risk.payload.zone">
        <div class="label">{{ "risks.zone" | translate }}</div>
        <div class="value">{{ risk.payload.zone }}</div>
      </div>
      <div class="group" *ngIf="risk.unitName || risk.unit?.name">
        <div class="label">{{"units.unit" | translate }}</div>
        <div class="value">{{ risk.unitName || risk.unit?.name}}</div>
      </div>
      <div class="group" *ngIf="!risk.unitName && !risk.unit?.name && risk.trackerName">
        <div class="label">{{"units.tracker" | translate }}</div>
        <div class="value">{{ risk.trackerName }}</div>
      </div>
    </div>
    <div class="group full" *ngIf="linkedActions.length">
      <div class="label">{{ "actions.title" | translate }}</div>
      <div class="action-chips">
        <a *ngFor="let a of linkedActions" class="action-chip" (click)="openAction(a.id)">
          <lib-chip color="primary" icon="checklist" [text]="a.title"></lib-chip>
        </a>
      </div>
    </div>

    <div class="group full">
      <div class="label">{{ "risks.comment" | translate }}
        <span class="author">{{risk.payload.commentedBy}}</span>
      </div>
      <mat-form-field class="input-full-width" appearance="outline">
        <textarea matInput [(ngModel)]="risk.payload.comment" (blur)="onCommentEdit(risk)" rows="3"></textarea>
      </mat-form-field>
    </div>
    <ng-container [ngTemplateOutlet]="groupButtonTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #groupButtonTemplate>
  <div class="group-button">
    <lib-button [icon]="'image_file'" [text]="'risks.ask_image' | translate" [color]="'primary'" (click)="onShowImage(risk)">
    </lib-button>
    <lib-button [icon]="'error'" [color]="'warning'" [text]="'risks.report_title' | translate" (click)="reportRisk(risk)">
    </lib-button>
    <lib-button [icon]="'checklist'" [color]="'secondary'" [text]="'actions.create_from_risk' | translate" (click)="createAction(risk)">
    </lib-button>
  </div>
</ng-template>